// src/pages/Leaderboard.tsx
import React, { useEffect, useState } from 'react'
import api from '../api/axios'
import './Leaderboard.css'

type Leader = {
  userId:     string
  username:   string
  level:      number
  xp:         number
  xp_to_next: number
}

export default function LeaderboardPage() {
  const [leaders, setLeaders] = useState<Leader[]>([])
  const [error, setError]     = useState<string | null>(null)
  const [loading, setLoading] = useState(true)
  const [page, setPage]       = useState(0)

  useEffect(() => {
    api.get<Leader[]>('/leaderboard')
      .then(res => {
        setLeaders(res.data)
      })
      .catch(err => {
        setError(err.response?.data?.error || err.message)
      })
      .finally(() => {
        setLoading(false)
      })
  }, [])

  const perPage     = 10
  const totalPages  = Math.ceil(leaders.length / perPage)
  const startIndex  = page * perPage
  const pageLeaders = leaders.slice(startIndex, startIndex + perPage)

  return (
    <div className="leaderboard-page">
      <div className="leaderboard-container">

        {loading && (
          <p className="loading">Loading leaderboard…</p>
        )}

        {!loading && error && (
          <p className="error">{error}</p>
        )}

        {!loading && !error && (
          <>
            <ol className="leader-list">
              {pageLeaders.map(({ userId, username, level, xp, xp_to_next }, idx) => (
                <li key={userId} className="leader-entry">
                  <span className="rank">#{startIndex + idx + 1}</span>
                  <span className="name">{username}</span>
                  <span className="stats">
                    Lv. {level} ({xp}/{xp_to_next} XP)
                  </span>
                </li>
              ))}
            </ol>

            <div className="pagination">
              <button
                onClick={() => setPage(p => Math.max(0, p - 1))}
                disabled={page === 0}
              >
                ← Previous
              </button>
              <span className="page-info">
                Page {page + 1} of {totalPages}
              </span>
              <button
                onClick={() => setPage(p => Math.min(totalPages - 1, p + 1))}
                disabled={page + 1 >= totalPages}
              >
                Next →
              </button>
            </div>
          </>
        )}

      </div>
    </div>
  )
}
